import { randomString } from "@fry/lib/utils";
import { BoardCard } from "./board-card";
import { BoardColumnJSON } from "./json";

export class BoardColumn {

    public id: string;

    public title: string;

    public cards: BoardCard[];

    public constructor(title: string, cards: BoardCard[], id?: string) {
        this.id = id || randomString();
        this.title = title;
        this.cards = cards;
    }

    public toJSON(): BoardColumnJSON {
        return { id: this.id, title: this.title, cards: this.cards.map(card => card.toJSON()) };
    }
}
